import React from 'react'
import { Helmet } from 'react-helmet'
import Banner1 from '../components/banner1'
import ContactForm2 from '../components/contact-form2'
import './home.css'

const Home = () => (
  <div className="home-container10">
    <Helmet>
      <title>NuggetCraft SMP</title>
      <meta name="description" content="Welcome to NuggetCraft SMP — rules, community information, and applications." />
      <meta property="og:title" content="NuggetCraft SMP" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://kcserver.cc/" />
      <link rel="canonical" href="https://kcserver.cc/" />
    </Helmet>

    <Banner1
      heading1="Welcome to NuggetCraft SMP"
      content1="Explore the rules, meet the admins, and apply to join our community."
      action1="View Rules"
      actionHref="/rules"
    />

    <main className="home-main">
      <section className="home-team thq-section-padding">
        <div className="home-max-width thq-section-max-width">
          <h2 className="thq-heading-2">Meet the Admins</h2>
          <p className="thq-body-large home-intro">
            We aim to bring fun, excitement, and justice to the server, no matter who is on the receiving end.
          </p>

          <div className="home-admin-grid">
            <article className="home-admin-card">
              <img src="/My%20pfp-200h.png" alt="TheMandolorian7" className="home-admin-avatar" />
              <h3 className="thq-heading-3">TheMandolorian7</h3>
              <p className="home-role">Server Founder &amp; Owner</p>
              <p className="thq-body-small">
                As owner of NuggetCraft SMP, TheMandolorian7 works to keep the server online and maintain a fair, welcoming community.
              </p>
            </article>

            <article className="home-admin-card">
              <img src="/avatar-full-200h.png" alt="SkywardOcean15" className="home-admin-avatar" />
              <h3 className="thq-heading-3">SkywardOcean15</h3>
              <p className="home-role">Official Server Helper</p>
              <p className="thq-body-small">
                SkywardOcean15 helps players, answers questions, and supports the administration team.
              </p>
            </article>
          </div>
        </div>
      </section>

      <ContactForm2
        heading1="Apply To Join"
        content1="We handpick players for our server to create the best community that we possibly can."
      >
        <div className="home-form-wrapper">
          <iframe
            title="NuggetCraft SMP application form"
            src="https://docs.google.com/forms/d/e/1FAIpQLSd2kHWBei7L2JYEsP3tOi8lQ3P_k2VRDUGBvwyot_7SYJNQHQ/viewform?embedded=true"
            className="home-form"
            loading="lazy"
          >
            Loading application form…
          </iframe>
        </div>
      </ContactForm2>
    </main>
  </div>
)

export default Home
